import builder from '../builder';
import LockShield from '../../streamline-icons/light/lock-shield.svg';

export default builder('IconLockShieldLight', LockShield);
